import { FC } from "react";

import { HALF_FACTOR } from "@ryde/shared";

import {
  MAPLIBRE_VEHICLE_CAR_EDGE_INSET_PX,
  MAPLIBRE_VEHICLE_CAR_SIZE_PX,
} from "./maplibre-vehicle-car-marker.constants";

/**
 * The vehicle marker's filled disc. A real `<circle>` rather than a CSS-rounded box because MapLibre scales
 * HTML markers with the map and stretched the Leaflet `.map-marker-simple-icon` div into ovals. Its own
 * component so the marker wrapper only composes the disc with the imported car glyph.
 */
export const MapLibreVehicleCarCircle: FC = () => {
  const center = MAPLIBRE_VEHICLE_CAR_SIZE_PX / HALF_FACTOR;

  return (
    <svg
      width={MAPLIBRE_VEHICLE_CAR_SIZE_PX}
      height={MAPLIBRE_VEHICLE_CAR_SIZE_PX}
      viewBox={`0 0 ${MAPLIBRE_VEHICLE_CAR_SIZE_PX} ${MAPLIBRE_VEHICLE_CAR_SIZE_PX}`}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <circle
        className="maplibre-vehicle-car-fill"
        cx={center}
        cy={center}
        r={center - MAPLIBRE_VEHICLE_CAR_EDGE_INSET_PX}
      />
    </svg>
  );
};
